"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
}(exports, function (e) {
  var t = {};function r(i) {
    if (t[i]) return t[i].exports;var s = t[i] = { i: i, l: !1, exports: {} };return e[i].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
  }return r.m = e, r.c = t, r.d = function (e, t, i) {
    r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var i = Object.create(null);if (r.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var s in e) {
      r.d(i, s, function (t) {
        return e[t];
      }.bind(null, s));
    }return i;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 117);
}({ 0: function _(e, t) {
    e.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(e, t) {
          var r = void 0;"function" == typeof Event ? r = new Event(t) : (r = document.createEvent("Event"), r.initEvent(t, !0, !0)), e.dispatchEvent(r);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(e, t) {
          return t ? document.querySelector("[" + e + "=\"" + t + "\"]") : document.querySelector("[" + e + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(e, t) {
          return t ? document.querySelectorAll("[" + e + "=\"" + t + "\"]") : document.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(e, t, r) {
          return r ? e.querySelector("[" + t + "=\"" + r + "\"]") : e.querySelector("[" + t + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(e) {
          return Array.prototype.slice.call(e.parentElement.querySelectorAll(":hover")).filter(function () {
            return e[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(e, t, r) {
          return r ? e.querySelectorAll("[" + t + "=\"" + r + "\"]") : e.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(e, t) {
          return e.querySelector("." + t);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(e) {
          var t = void 0;return "function" == typeof Event ? t = new Event(e) : (t = document.createEvent("Event"), t.initEvent(e, !0, !0)), t;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(e) {
          var t = void 0;if (null != e) if (void 0 === e.code) switch (e.keyCode) {case 13:
              t = "Enter";break;case 38:
              t = "ArrowUp";break;case 40:
              t = "ArrowDown";break;case 8:
              t = "Backspace";break;case 9:
              t = "Tab";break;case 27:
              t = "Escape";break;case 33:
              t = "PageUp";break;case 34:
              t = "PageDown";break;case 32:
              t = "Space";break;default:
              t = void 0;} else t = e.code;return t;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(e) {
          return [].concat(_toConsumableArray(e.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (e) {
            return !function (e) {
              return "hidden" === window.getComputedStyle(e).visibility;
            }(e) && !e.hasAttribute("disabled") && !e.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 117: function _(e, t, r) {
    e.exports = r(118);
  }, 118: function _(e, t, r) {
    "use strict";
    r.r(t), r.d(t, "Popover", function () {
      return o;
    });var i = r(0),
        s = r.n(i),
        n = r(2);
    var o = function () {
      function o(e) {
        _classCallCheck(this, o);

        this.element = e, this.trigger = s.a.getElementByAttribute(this.attributes.trigger, this.element.getAttribute("data-rs-popover")), this.overlay = s.a.getElementByAttribute(this.attributes.overlay), this.disableOverlay = this.element.hasAttribute(this.attributes.disableOverlay), this.popoverOpen, this.addEventHandlers(), this.isOpenByDefault(), this.keystroke = 0;
      }

      _createClass(o, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.trigger && this.trigger.addEventListener("click", function () {
            _this.popoverOpen ? _this.closePopover(_this.popoverOpen) : _this.openPopover(_this.element), _this.toggleActiveClassOnTrigger();
          }), this.overlay && !this.disableOverlay && this.popoverOpen ? this.overlay.addEventListener("click", function () {
            _this.closePopover(_this.popoverOpen), _this.trigger && _this.toggleActiveClassOnTrigger();
          }) : window.addEventListener("click", function (e) {
            _this.popoverOpen && (_this.trigger && _this.trigger.contains(e.target) || _this.popoverOpen.contains(e.target) || (_this.closePopover(_this.popoverOpen), _this.trigger && _this.toggleActiveClassOnTrigger()));
          }), document.addEventListener("keydown", function (e) {
            _this.handleButtonKeys(e);
          });
        }
      }, {
        key: "isOpenByDefault",
        value: function isOpenByDefault() {
          return this.element.classList.contains(this.classes.popoverActive) ? this.popoverOpen = this.element : null;
        }
      }, {
        key: "openPopover",
        value: function openPopover(e) {
          e && (e.classList.add(this.classes.popoverActive), e.removeAttribute(this.attributes.hidden), null === this.overlay || this.disableOverlay || this.overlay.classList.add(this.classes.modalOverlayActive), this.popoverOpen = e);
        }
      }, {
        key: "closePopover",
        value: function closePopover(e) {
          e && (e.classList.remove(this.classes.popoverActive), e.setAttribute(this.attributes.hidden, "true"), this.overlay && !this.disableOverlay && this.overlay.classList.remove(this.classes.modalOverlayActive), this.popoverOpen = !1, this.keystroke = 0);
        }
      }, {
        key: "toggleActiveClassOnTrigger",
        value: function toggleActiveClassOnTrigger() {
          this.trigger.classList.contains(this.classes.active) ? this.trigger.classList.remove(this.classes.active) : this.trigger.classList.add(this.classes.active);
        }
      }, {
        key: "handleButtonKeys",
        value: function handleButtonKeys(e) {
          if (null != e) switch (s.a.getKeyCodeOnKeyDownEvent(e)) {case "Tab":
              Object(n.a)(e, this.element, this.popoverOpen, this.keystroke), this.popoverOpen && this.keystroke++;break;case "Escape":
              this.popoverOpen && (this.closePopover(this.popoverOpen), this.trigger && this.trigger.focus());}
        }
      }, {
        key: "classes",
        get: function get() {
          return { popoverActive: "popover--active", modalOverlayActive: "modal__overlay--active", active: "active" };
        }
      }, {
        key: "attributes",
        get: function get() {
          return { overlay: "data-rs-popover-overlay", trigger: "data-rs-popover-trigger", disableOverlay: "data-rs-popover-disable-overlay", hidden: "aria-hidden" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-popover]";
        }
      }]);

      return o;
    }();
  }, 2: function _(e, t, r) {
    "use strict";
    var i = r(0),
        s = r.n(i);t.a = function (e, t, r) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var n = s.a.getKeyboardFocusableElements(t),
          o = n[0],
          a = n[n.length - 1];if (r) {
        if (a.tagName && "IFRAME" === a.tagName) {
          var _e = document.createElement("div");_e.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e, a.nextSibling);
        }if (o.tagName && "IFRAME" === o.tagName) {
          var _e2 = document.createElement("div");_e2.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e2, a.nextSibling), o.parentNode.insertBefore(_e2, o);
        }i < 1 && (e.preventDefault(), setTimeout(function () {
          o.focus();
        }, 100)), e.shiftKey ? document.activeElement === o && (e.preventDefault(), a.focus()) : document.activeElement === a && (e.preventDefault(), o.focus());
      }
    };
  } }));